import Page from '../../components/layouts/page'
import SchemasTable from '../../components/schemas_table'

const Schemas = () => {
  return (
    <Page title='Schemas'>
      <SchemasTable queryKey={['schemas']} />
    </Page>
  )
}

export default Schemas
